import { render, staticRenderFns } from "./WPButtonPlain.vue?vue&type=template&id=9fcd85ac"
import script from "./WPButtonPlain.vue?vue&type=script&lang=ts"
export * from "./WPButtonPlain.vue?vue&type=script&lang=ts"
import style0 from "./WPButtonPlain.vue?vue&type=style&index=0&id=9fcd85ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports